import axios from "axios";
import React, { createContext, useState } from "react";

import Urls from "../../../../libraries/src/services/atoms/urls";
// import { Request } from "../../../../libraries/src/services/atoms/Utils/Request";
const ScrutinyRemarksContext = createContext();

const ScrutinyRemarksProvider = ({ children }) => {
  const [chatBoardHistoryData, setChatBoardHistoryData] = useState({});
  const [chatBoardDataRemarks, setChatBoardDataRemarks] = useState({});
  const [remarksData, setRemarksData] = useState({});
  const [notingRemarksData, setNotingRemarksData] = useState({});
  const [nocRemarksData, setNocRemarksData] = useState({});
  const [paymentHeadRemarksData, setPaymentHeadRemarksData] = useState({});
  const [documentRemarksData, setDocumentRemarksData] = useState({});
  const [khasraDetailsData, setKhasraDetailsData] = useState({});
  const [siteInspectionRemarksData, setSiteInspectionRemarksData] = useState({});
  const [siteDrawingRemarksData, setSiteDrawingRemarksData] = useState({});
  const [pFarDetailsData, setpFarDetailsData] = useState({});
  // const [siteNotingRemarksData, setSiteNotingRemarksData] = useState({});
  const [iconStates, setIconState] = useState(null);
  const [rolesDate, setRolesData] = useState(null);
  const [bussinessService, setBusinessService] = useState("");

  const userInfo = Digit.UserService.getUser()?.info || {};
  const authToken = Digit.UserService.getUser()?.access_token || null;

  const handleGetRemarkssValues = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.land.chatBoard_data_search}=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog123", Resp);
      setChatBoardDataRemarks(Resp);
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetHistoryRemarkssValues = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.land.chatBoard_data_search3}=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      setChatBoardHistoryData(Resp);
      console.log(Resp, "Ashwini123");
    } catch (error) {
      console.log(error);
    }
  };

  // const handleGetFiledsStatesById=async(applicationNumber)=>{
  //     const dataToPass={
  //       "RequestInfo": {
  //           "api_id": "1",
  //           "ver": "1",
  //           "ts": null,
  //           "action": "create",
  //           "did": "",
  //           "key": "",
  //           "msg_id": "",
  //           "requester_id": "",
  //           "authToken": authToken
  //       }
  //   };
  //   try {
  //     const Resp = await axios.post(`${Urls.land.modal_data_search}=${applicationNumber}`, dataToPass).then((response) => {
  //         console.log("ResponseFromLog11111111", Resp ,response.data );
  //         return response.data;
  //     });
  //     console.log("ResponseFromLog2222", Resp);
  //     setIconState(Resp);
  //   } catch (error) {
  //     console.log(error);
  //   }

  // }

  const handleGetFiledsStatesById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.land.modal_data_search}=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setNotingRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetPaymentHeadById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.remarksPaymentDetails}&applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setPaymentHeadRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetDocumentById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.remarksDocument}&applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setDocumentRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetKhasraById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.khasraDetails}&applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setKhasraDetailsData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetSiteInspectionById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.remarksSiteInspection}&applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setSiteInspectionRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetDrawingById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.remarksDrawing}&applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      // console.log("ResponseFromLog2222", Resp);
      setSiteDrawingRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
   const handlepFarDetailById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.remarkspFARDetail}&applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      // console.log("ResponseFromLog2222", Resp);
      setpFarDetailsData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetNotingById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.remarksNoting}applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLog2222", Resp);
      setNotingRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetNocById = async (applicationNumber) => {
    const dataToSend = {
      RequestInfo: {
        apiId: "Rainmaker",
        action: "_create",
        did: 1,
        key: "",
        msgId: "20170310130900|en_IN",
        ts: 0,
        ver: ".01",
        authToken: authToken,
      },
    };
    try {
      const Resp = await axios.post(`${Urls.bpaService.remarksNoc}&applicationNo=${applicationNumber}`, dataToSend).then((response) => {
        return response.data;
      });
      console.log("ResponseFromLogNoc", Resp);
      setNocRemarksData(Resp);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <ScrutinyRemarksContext.Provider
      value={{
        remarksData,
        notingRemarksData,
        iconStates,
        rolesDate,
        paymentHeadRemarksData,
        documentRemarksData,
        siteInspectionRemarksData,
        siteDrawingRemarksData,
        pFarDetailsData,
        nocRemarksData,
        setSiteDrawingRemarksData,
        setpFarDetailsData,
        handleGetNotingById,
        handleGetNocById,
        handleGetDrawingById,
        handlepFarDetailById,
        handleGetSiteInspectionById,
        handleGetFiledsStatesById,
        handleGetDocumentById,
        handleGetPaymentHeadById,
        bussinessService,
        setBusinessService,
        handleGetRemarkssValues,
        handleGetHistoryRemarkssValues,
        chatBoardDataRemarks,
        chatBoardHistoryData,
        khasraDetailsData,
        handleGetKhasraById,
      }}
    >
      {children}
    </ScrutinyRemarksContext.Provider>
  );
};

export { ScrutinyRemarksContext, ScrutinyRemarksProvider };
